/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import qs from 'query-string'

import Request from 'generic/request/Request'

export const DOCUMENT_LIST_URL = '/api/document/list/'
export const DOCUMENT_URL = '/api/document/'
export const FILE_URL = '/api/file/'

export const getDocuments = (params) => {
  const query = {
    ...params,
    meta: false,
    objects_count: false,
  }

  return Request.getRequest(DOCUMENT_LIST_URL + '?' + qs.stringify(query))
    .then((result) => {
      return result.data.objects
    })
}

export const getDocument = (uid) => {
  return Request.getRequest(DOCUMENT_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      return result.data.object
    })
}

export const postDocument = (obj) => {
  return Request.postRequest(DOCUMENT_URL + (obj.uid ? obj.uid + '/' : ''), obj)
    .then((result) => {
      return result.data.object
    })
}

export const deleteDocument = (obj) => {
  return Request.deleteRequest(DOCUMENT_URL + obj.uid + '/')
}

export const postFile = (obj) => {
  return Request.postRequest(FILE_URL, obj)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Document.js